// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aDDr","input":"styles_input__3Jv3e"};